/**
 * Show a modal pop-up overlay over the current page.
 *
 * @param {string} callback.component - The component to show in the modal.
 * @param {Object} [callback.props={}] - Additional properties to be passed on to the modal component.
 * @param {Object} [callback.params={}] - Parameters for configuring the modal.
 * @param {Object} [callback.events={}] - Event listeners for the modal.
 * @param {boolean} [callback.once=false] - The modal will only open if there is no existing modal currently rendered, if true.
 *
 * @link https://euvl.github.io/vue-js-modal/Events.html
 */
export default function (component, props = {}, params = {}, events = {}, once = false) {
  const defaultParams = { classes: ["v--custom-modal"], clickToClose: true, transition: "" };
  const mergedParams = { ...defaultParams, ...params };

  Bus.$emit("showModal", component, props, mergedParams, events, once);
}
